import SubPackBadgeCarousel from '@/components/member/widgets/SubPackBadgeCarousel';

/**
 * Sub Pack Vault — read-only display of the member's owned Sub Packs with
 * live drip-release countdowns. Polling is scoped to this subpage only;
 * the dashboard no longer carries this load.
 */
const SubPackVaultSubpage = () => {
  return (
    <div className="space-y-6" data-testid="subpage-subpack-vault">
      <section className="sc-glass-strong rounded-2xl p-5 md:p-6">
        <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
          <div>
            <h2 className="font-display font-bold text-xl md:text-2xl">Your Sub Pack Vault</h2>
            <p className="text-[13px] text-[var(--sc-text-dim)] mt-1">
              Active Sub Packs you own and their live position-release countdowns. Each Sub Pack drips positions into the rotator automatically until fully
              depleted.
            </p>
          </div>
        </div>
        <SubPackBadgeCarousel />
      </section>
    </div>
  );
};

export default SubPackVaultSubpage;
